import CreateEvaluationForm from '../../../components/Evaluation/CreateEvaluationForm';

const CreateEvaluation = () => {
    return (
        <main className="create-evaluation-view">
            <CreateEvaluationForm />
        </main>
    );
};

export default CreateEvaluation;
